import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  Company,
  Token,
  UserDetails,
  UserSignInInfo,
  Subscription,
} from '../app.model';
import {AppService} from '../app.service';
import {CacheService} from '../cache.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {CommonDialogComponent} from '../common-dialog/common-dialog.component';
import {environment} from '../../environments/environment';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {MatLegacySnackBar as MatSnackBar} from '@angular/material/legacy-snack-bar';
//import

// import {MixpanelService} from '../services/mixpanel.service';
import {HubspotService} from '../services/hubspot/hubspot.service';
import {get, includes} from 'lodash-es';
import {
  NS_Enums,
  oldPricingRoute,
  trialStarterConfigureDestination,
  trialStarterHeading,
} from '../shared/namespaces';
import {TrialPlanService} from '../services/trialplan/trialplan.service';
import {getRolesFromToken, getUserIdFromToken, getUserInfoFromToken} from 'src/app/shared/helpers/jwt.helper';
import {isLocalStorageAvailable} from 'src/app/shared/helpers/helpers';
import {isLocal} from 'src/app/shared/helpers/local.helper';
import {trackFreshsalesEvent} from 'src/app/shared/helpers/faitracker-defense';
import * as Sentry from '@sentry/angular';
import {CookieConsentService} from '../shared/services/cookie-consent.service';
import {RedirectionService} from '../services/redirection/redirection.service';
import {EMPTY, Subscription as rxSubscription} from 'rxjs';
import {catchError, timeout} from 'rxjs/operators';
import {AuthService, USER_STORAGE_KEY} from './auth.service';
import {ReCaptchaV3Service} from 'ng-recaptcha';
import { traceFailure, traceStep } from '../shared/helpers/handoff-trace.helper';
import {
  captureIqSetupFromWindow,
  getIqSetupNavigateUrl,
  isIqSetupActive,
} from '../shared/helpers/iq-setup-context.helper';
import {
  clearExplicitLogout,
  isExplicitLogoutPending,
  markExplicitLogout,
} from '../shared/helpers/explicit-logout.helper';

/** Pause on the welcome card after a direct login, before routing. */
const WELCOME_DELAY_MS = 2000;

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit, OnDestroy {
  TLD: boolean = true;
  invalidEmailCompany: boolean = false;
  currentDomain: string;
  exampleBusinessEmail = 'name@company.com';
  invalidEmailHosts: string[] = ['gmail', 'yahoo', 'hotmail'];
  userData: any;
  companies: Company[] = [];
  userSignUpInfo = new UserDetails();
  userSignInInfo: UserSignInInfo = new UserSignInInfo();
  verifyPassword: string;
  agreeTUP: boolean;
  rememberMe: boolean;
  showForgotPassword: boolean;
  userForgotPassword: UserSignInInfo = new UserSignInInfo();
  form: HTMLFormElement;
  showLoginBlock = false;
  showcheckemail = false;
  userId = 0;
  baseWord: string = this.appService.getBaseWord();
  uncommonBaseWord: string = this.appService.getUncommonBaseWord();
  signedUp = false;
  fieldTextType_P: boolean;
  fieldTextType_CP: boolean;
  strong_password = false;
  medium_password = false;
  weak_password = false;
  text_value = 'hide';
  under_signIn_process = false;
  trialSubscriptionPlan: Subscription = new Subscription();
  private appUrl = environment.apiUrl;
  under_creating_account = false;
  userRole: string[] | string = [];
  counter: number = 0;
  carousel = [];
  showCookieCheckbox = true;
  routerEventsSubscription: rxSubscription;

  private customToken: string = '';
  private token: string = '';
  private name: string = '';
  private email: string = '';
  private uId: string = '';
  private tokenObj: Token | null = null;
  userInfo: any;

  showSpinner: boolean = true;
  showWelcomeMsg: boolean = false;
  showFailedMsg: { code: string } | false = false;

  welcomeSuperText: string = '';
  welcomeTitle: string = '';
  welcomeSubTitle: string = '';

  constructor(
    private snackBar: MatSnackBar,
    private appService: AppService,
    private trialPlanService: TrialPlanService,
    private cacheService: CacheService,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private afAuth: AngularFireAuth,
    private authService: AuthService,
    private redirectService: RedirectionService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private hubspotService: HubspotService, // Inject Firebase auth service //  private mixpanel: MixpanelService
    public cookieConsentService: CookieConsentService
  ) {
    this.afAuth.authState.subscribe((user) => {
      if (user) {
        this.userData = user;
      }
    });
  }

  ngOnInit() {
    captureIqSetupFromWindow();
    traceStep('auth_init', {
      hasTokenParam: !!this.route.snapshot.queryParamMap.get('token'),
      hasRedirectTo: !!this.route.snapshot.queryParamMap.get('redirectTo'),
      iqSetup: isIqSetupActive(),
      hasCachedAuth: !!this.cacheService.getObject<Token>(NS_Enums.cacheKeysEnum.saras_auth_key),
    });
    const earlyToken = this.route.snapshot.queryParamMap.get('token');
    const earlyUser = this.route.snapshot.queryParamMap.get('user');
    if (earlyToken || earlyUser) {
      clearExplicitLogout();
    }
    const saras_auth_key = this.cacheService.getObject<Token>(NS_Enums.cacheKeysEnum.saras_auth_key);
    const hasValidAuth = this.cacheService.hasValidAuthKey(saras_auth_key);
    const saras_shared: any = this.cacheService.getObject(NS_Enums.cacheKeysEnum.saras_shared) || {
      daton: {
        superText: 'Welcome to',
        title: 'Saras Daton',
        subTitle: 'Your Unified Data Platform'
      }
    };
    this.welcomeSuperText = saras_shared?.daton?.superText;
    this.welcomeTitle = saras_shared?.daton?.title;
    this.welcomeSubTitle = saras_shared?.daton?.subTitle;
    this.renderUserInfoFromParam();
    this.showWelcomeMsg = false;
    if (earlyToken && !hasValidAuth) {
      this.appService.authValidationInProgress = true;
    }
    this.recaptchaV3Service.execute('login').pipe(
      timeout(10000),
      catchError((error) => {
        this.appService.authValidationInProgress = false;
        console.log(error);
        return EMPTY;
      })
    ).subscribe(token => {
      if (window[NS_Enums.windowKeysEnum.global_status] === 'DIFFERENT_USER') {
        const saras_global: any = this.cacheService.getObject(NS_Enums.saras_global);
        const globalToken = saras_global?.token;

        this.cacheService.remove(NS_Enums.cacheKeysEnum.saras_auth_key);
        this.cacheService.remove(NS_Enums.cacheKeysEnum.user_details);
        if (isLocalStorageAvailable()) {
          localStorage.removeItem(USER_STORAGE_KEY);
        }

        window[NS_Enums.windowKeysEnum.global_status] = null;

        this.renderParamsAndVerify(globalToken);
      } else {
        // Redirect params always win: skip the cached-session fast path so a
        // global-web-app handoff is verified fresh (no double-verify without them).
        if (earlyToken || earlyUser) {
          this.resetStaleAuth();
          this.renderParamsAndVerify();
          return;
        }

        if (hasValidAuth) {
          // token-only keys carry no userId; fall back to decoding the JWT
          this.userId =
            saras_auth_key.userId ?? getUserIdFromToken(saras_auth_key.token) ?? 0;
        }
        const emailQueryParam = this.route.snapshot.queryParamMap.get('email');
        if (emailQueryParam && !this.signedUp) {
          this.userSignUpInfo.email = emailQueryParam;
        } else if (emailQueryParam && this.signedUp) {
          this.userSignInInfo.email = emailQueryParam;
        }

        if (hasValidAuth && this.authService.isLoggedIn) {
          if (!this.cacheService.isCurrentUserSameAsGlobalLogin()) {
            this.router.navigate(['logout']);
          } else {
            this.appService.getUserLoginEvent().next(true);
            if (this.redirectToRequestedRoute()) {
              return;
            }
            if (this.userId) {
              if (isIqSetupActive()) {
                this.router.navigateByUrl(getIqSetupNavigateUrl(this.baseWord));
              } else {
                this.router.navigate([`/${this.baseWord}/datasources-listing`]);
              }
            } else {
              this.routeBackFromLogin();
              this.routeToTopics();
            }
          }
        } else {
          if (!hasValidAuth) {
            this.resetStaleAuth();
          }
          setTimeout(() => {
            this.renderParamsAndVerify();
          }, 10);
        }
      }
    });
  }

  /**
   * Decodes and returns user info from the `user` query parameter.
   *
   * Fallback behavior: if the `user` param is absent, malformed base64, or
   * contains invalid JSON, the method falls back to the cached user details
   * stored under `NS_Enums.cacheKeysEnum.user_details`. A Sentry breadcrumb
   * at level `warning` is recorded via `addAuthDecodeBreadcrumb` whenever
   * a decode failure occurs.
   */
  renderUserInfoFromParam() {
    const encryptedUserInfo =
      this.route.snapshot.queryParamMap.get('user') || '';
    if (encryptedUserInfo) {
      try {
        this.userInfo = JSON.parse(atob(encryptedUserInfo));
        this.cacheService.storeObject(
          NS_Enums.cacheKeysEnum.user_details,
          this.userInfo
        );
      } catch (error) {
        this.addAuthDecodeBreadcrumb('Failed to decode user info from query param', error);
        this.userInfo = this.cacheService.getStoreObject(
          NS_Enums.cacheKeysEnum.user_details
        );
      }
    } else {
      this.userInfo = this.cacheService.getStoreObject(
        NS_Enums.cacheKeysEnum.user_details
      );
    }
    return this.userInfo;
  }

  /**
   * Drops invalid or outdated Daton auth so a global-web-app redirect token
   * is always verified instead of reusing stale cookie / Firebase session state.
   */
  private resetStaleAuth() {
    this.cacheService.remove(NS_Enums.cacheKeysEnum.saras_auth_key);
    if (isLocalStorageAvailable()) {
      localStorage.removeItem(USER_STORAGE_KEY);
    }
    this.userId = 0;
  }

  /**
   * Reads token query params (or an optional shared token) and starts Firebase
   * verification.
   *
   * Fallback behavior: when no `token` param and no `sharedToken` are present,
   * redirects to login. If the `token` param is malformed base64, records a
   * Sentry breadcrumb at level `warning` via `addAuthDecodeBreadcrumb` and
   * redirects to login instead of calling `verifyFirebaseToken`.
   *
   * @param sharedToken - Optional token from global login (e.g. DIFFERENT_USER flow)
   */
  renderParamsAndVerify(sharedToken: string = '') {
    const encryptedToken =
      this.route.snapshot.queryParamMap.get('token') || '';
    this.name =
      this.route.snapshot.queryParamMap.get('name') || '';
    this.email =
      this.route.snapshot.queryParamMap.get('email') || '';
    // If daton user differs from global login, cache was cleared and we re-verify via firebase
    if (sharedToken) {
      this.token = sharedToken;
      this.verifyFirebaseToken(this.token);
    } else if (encryptedToken) {
      try {
        this.token = atob(encryptedToken);
      } catch (error) {
        this.addAuthDecodeBreadcrumb('Failed to decode token from query param', error);
        this.redirectService.redirectToLogin();
        return;
      }
      this.verifyFirebaseToken(this.token);
    } else {
      // Local dev only: iQ writes the shared `saras_global` cookie on `localhost`, so sign in
      // from it (as iQ -> Pulse does) instead of bouncing through the local accounts app.
      const globalCookie = isLocal
        ? this.cacheService.getObject<{
            token?: string;
            user?: { email: string; firstName: string; lastName: string };
          }>(NS_Enums.saras_global)
        : null;
      const globalToken = globalCookie?.token;
      if (globalToken && !isExplicitLogoutPending()) {
        // No `user` handoff param here, so build the user info the custom-token call needs
        // from the cookie's `user` (if present) or the token claims.
        if (!this.userInfo) {
          this.userInfo =
            globalCookie.user ||
            getUserInfoFromToken(globalToken) || { email: '', firstName: '', lastName: '' };
          this.cacheService.storeObject(NS_Enums.cacheKeysEnum.user_details, this.userInfo);
        }
        this.token = globalToken;
        this.verifyFirebaseToken(this.token);
        return;
      }
      this.redirectService.redirectToLogin();
    }
  }

  verifyFirebaseToken(token) {
    traceStep('verify_firebase_token_start');
    this.appService.authValidationInProgress = true;
    this.appService
      .verifyFirebaseToken(token)
      .then((saras_token: any) => {
        const token = new Token();
        const rolesFromToken = getRolesFromToken(saras_token.token);
        token.role = saras_token.role;
        token.token = saras_token.token;
        token.userId = saras_token.userId;
        token.tokenId = saras_token.uid;
        this.userRole = rolesFromToken || saras_token.role;
        this.tokenObj = token;

        if (environment.apiUrl === 'https://webapi.sarasanalytics.com/') {
          window['dataLayer'] = window['dataLayer'] || [];
          window['dataLayer'].push({
            event: 'Sign-in',
            eventCategory: 'Sign-in',
            eventAction: 'Success',
          });
        }

        this.getCustomToken(
          (token?.tokenId || '').toString(),
          this.userInfo.email,
          this.userInfo.firstName + ' ' + this.userInfo.lastName,
          rolesFromToken
        );

        // if(isAfterSignUp){
        //   this.trialPlanService.doWhenNewUserSignUpReported(this.userSignUpInfo.email);
        // }
      })
      .catch((error) => {
        // `handleError` rejects with the message only; the HTTP status of each try is already
        // in the timeline, as the interceptor's `http_error` steps.
        traceFailure('verify_firebase_token');
        this.under_signIn_process = false;
        this.under_creating_account = false;
        this.appService.authValidationInProgress = false;
        console.log(error);
      });
  }

  getCustomToken(uid: string, email: string, name: string, roles: string[]) {
    try {
      this.appService
        .getCustomToken(uid, email, name, roles)
        .then((res: any) => {
          traceStep('custom_token_ok');
          /* SIGN IN */
          this.authenticateToken(res.data);
        })
        .catch((e) => {
          console.log(e);
          this.handleAuthFailure(e, 'TOKEN_FETCH_FAILED');
        });
    } catch (e) {
      console.log(e);
      this.handleAuthFailure(e, 'TOKEN_FETCH_FAILED');
    }
  }

  authenticateToken(customToken: string) {
    try {
      /* GET CUSTOM TOKEN */

      this.afAuth
        .signInWithCustomToken(customToken)
        .then((result: any) => {
          this.userData = result.user;
          return result.user.getIdTokenResult();
        })
        .then((idTokenResult) => {
          const {token} = idTokenResult;
          this.authService.globalAuthInitialized = true;

          if (environment.apiUrl === 'https://webapi.sarasanalytics.com/') {
            window['dataLayer'] = window['dataLayer'] || [];
            window['dataLayer'].push({
              event: 'Sign-up',
              eventCategory: 'Sign-Up',
              eventAction: 'Success',
            });
            trackFreshsalesEvent('signup');
          }
          this.appService.authValidationInProgress = false;
          traceStep('firebase_sign_in_ok');
          this.showWelcomeMessageAndProceed();
          // this.verifyFirebaseToken(token);

          // Show Authentication Failure Message
        })
        .catch((e) => {
          console.log('***** signInWithCustomToken', e);
          this.handleAuthFailure(e, 'SIGN_IN_FAILED');
        });
    } catch (e) {
      console.log(e);
      this.handleAuthFailure(e, 'SIGN_IN_FAILED');
    }
  }

  private addAuthDecodeBreadcrumb(message: string, error: unknown): void {
    Sentry.addBreadcrumb({
      category: 'auth',
      message,
      level: 'warning',
      data: { error: error instanceof Error ? error.message : String(error) },
    });
  }

  private showWelcomeMessageAndProceed() {
    // Coming from iQ's setup wizard the user already knows what they are doing and why, so skip
    // the welcome card and its fixed pause. Direct logins keep both.
    const fromIqSetup = isIqSetupActive();
    const delayMs = fromIqSetup ? 0 : WELCOME_DELAY_MS;
    traceStep('welcome_delay_start', { delayMs, skippedForIqSetup: fromIqSetup });
    this.showSpinner = false;
    this.showWelcomeMsg = !fromIqSetup;
    setTimeout(() => {
      this.showWelcomeMsg = false;
      this.showSpinner = false;
      this.cacheService.putObject('saras_auth_key', this.tokenObj, true);
      this.cacheService.putObject('time-laps', new Date().getTime(), true);

      traceStep('welcome_delay_end');
      this.appService.getUserLoginEvent().next(true);
      if (this.redirectToRequestedRoute()) {
        this.under_signIn_process = false;
        this.under_creating_account = false;
        return;
      }
      this.routeBackFromLogin();
      this.routeToTopics();
      this.under_signIn_process = false;
      this.under_creating_account = false;
    }, delayMs);
  }

  /**
   * Navigates to the internal route specified in the `redirectTo` query parameter
   * (preserving iQ setup context when present).
   */
  redirectToRequestedRoute(): boolean {
    const redirectTo = this.route.snapshot.queryParamMap.get('redirectTo');
    if (!redirectTo) {
      return false;
    }
    let target: string | null = null;
    try {
      const url = new URL(redirectTo);
      if (url.pathname) {
        target = `${url.pathname}${url.search}`;
      }
    } catch {
      if (redirectTo.startsWith('/')) {
        target = redirectTo;
      }
    }
    if (!target) {
      return false;
    }
    captureIqSetupFromWindow();
    this.router.navigateByUrl(target);
    return true;
  }

  routeBackFromLogin() {
    let routeBack = this.route.snapshot.queryParamMap.get('routeTo');
    if (routeBack === null) {
      routeBack = '/';
    }
    this.router.navigate([routeBack]);
  }

  routeToTopics() {
    if (isIqSetupActive()) {
      traceStep('route_decision', { target: getIqSetupNavigateUrl(this.baseWord), reason: 'iq_setup' });
      this.router.navigateByUrl(getIqSetupNavigateUrl(this.baseWord));
      return;
    }
    const saras_auth_key = this.cacheService.getObject<Token>(NS_Enums.cacheKeysEnum.saras_auth_key);
    if (saras_auth_key) {
      this.userId = saras_auth_key.userId;
      this.appService
        .getCurrentSubscriptionPlan(this.userId)
        .then((response) => {
          const body = response.body;
          if (body.userSubscriptionId === 0) {
            this.disableComponents();
            const freeTrialQueryParam =
              this.route.snapshot.queryParamMap.get('free_trial');
            if (freeTrialQueryParam === '1') {
              this.routeToPricing(true);
            } else {
              this.appService
                .getEnabledWarehouseList(this.userId)
                .then((warehouses) => {
                  if (
                    warehouses.find(
                      (warehouse) => warehouse.status === 'ENABLED'
                    ) !== undefined
                  ) {
                    this.router.navigate(['/']);
                  } else {
                    this.appService
                      .getCurrentSubscriptionPlan(this.userId)
                      .then((data: any) => {
                        // console.log(data)
                        if (data.body.planId === '') {
                          this.freeTrialSubscribe();
                        } /*else if(data.body.planId === 'trial') {
                    this.snackBar.open(
                      'Your account is on trial period', '',
                      {duration: 2500, verticalPosition: 'top',horizontalPosition: 'center', panelClass: ['reload-snack-bar']});
                    this.router.navigate(['/' + this.baseWord + '/datawarehouses-listing']);
                  }*/
                      });
                  }
                });
            }
          } else {
            this.router.navigate(['/' + this.baseWord + '/integrations-list']);

            // this.appService.getTrialPlan(this.userId).then(trialPlan => {
            //   if (body.subscriptionPlanId === trialPlan.plan.subscriptionPlanId && trialPlan.expireIn === 0) {
            //     this.routeToPricing();
            //   } else {
            //     this.router.navigate(['/' + this.baseWord + '/integrations-list']);
            //   }
            // });

            // this.appService.getSourceCount(this.userId).then((count) => {
            //   if (count > 0) {
            //     this.routeToDashboard();
            //   } else {
            //     this.routeToIntegrations();
            //   }
            // });
          }
        });
    }
  }

  routeToPricing(free_trial = false) {
    let routeBack = this.route.snapshot.queryParamMap.get('routeTo');
    if (routeBack === null) {
      if (free_trial) {
        routeBack = oldPricingRoute;
        this.router.navigate([routeBack], {queryParams: {free_trial: '1'}});
      } else {
        routeBack = oldPricingRoute;
        this.router.navigate([routeBack]);
      }
    }
  }

  disableComponents() {
    this.cacheService.putObject(
      NS_Enums.cacheKeysEnum.disableDashboard,
      true,
      false
    );
    this.cacheService.putObject(
      NS_Enums.cacheKeysEnum.disableDasource,
      true,
      false
    );
    this.cacheService.putObject(
      NS_Enums.cacheKeysEnum.disableIntegrations,
      true,
      false
    );
    this.cacheService.putObject(
      NS_Enums.cacheKeysEnum.disablePricing,
      false,
      false
    );
  }

  freeTrialSubscribe() {
    if (isIqSetupActive()) {
      this.router.navigateByUrl(getIqSetupNavigateUrl(this.baseWord));
      return;
    }
    let afterFreeTrial = (trialPlan) => {
      this.signUpEvent(trialPlan);
      sessionStorage.setItem(
        NS_Enums.sessionStorageKeysEnum.isTrialSetupStepOneShown,
        JSON.stringify(true)
      );
      const dialogRef = this.dialog.open(CommonDialogComponent, {
        data: {
          title: trialStarterHeading,
          content: trialStarterConfigureDestination,
          image: 'successful',
          type: 'trialFlow',
          stepSection: [
            {
              text: 'Configure destination',
              status: 'current',
              colorCss: 'bg-blue',
            },
            {
              text: 'Configure source',
              status: 'next',
              colorCss: 'bg-gray-200',
            },
          ],
          buttons: [
            {
              title: 'Configure now',
              meta: '/connectors/datawarehouses-listing',
              type: 'redirect',
              class: 'confirm-dialog-later',
            },
          ],
        },
        disableClose: true,
      });
      // this.trialPlanUsed = true;
      dialogRef.afterClosed().subscribe((result) => {
        if (result?.type === 'redirect') {
          if (environment.apiUrl === 'https://webapi.sarasanalytics.com/') {
            trackFreshsalesEvent('freeTrialStarted');
          }

          //this.router.navigate([result.meta]);
          this.router.navigate([
            '/' + this.baseWord + '/connectors/datawarehouses-listing',
          ]);
        }
      });
    };

    this.appService.getTrialPlan(this.userId).then((trialPlan) => {
      console.log('old activateTrialPlan bypassed', this.userSignInInfo.email);
      afterFreeTrial(trialPlan);
      // if(includes(this.userSignInInfo.email, "@sarasanalytics.com")){
      //   // when new internal users, we are not calling activateTrialPlan API
      //   console.log("old activateTrialPlan bypassed", this.userSignInInfo.email);
      //   afterFreeTrial(trialPlan);
      // } else {
      //   //TODO when external users are also allowed for new subscription feature then we should not call below activateTrialPlan API
      //   this.appService.activateTrialPlan(this.userId, trialPlan.plan).then((response) => {
      //     console.log("old activateTrialPlan called for external user", this.userSignInInfo.email);
      //     afterFreeTrial(trialPlan);
      //   });
      // }
    });
  }

  /*sendVerifcation() {
    this.userData.sendEmailVerification();
    return auth.currentUser.sendEmailVerification()
      .then(() => {
        this.router.navigate(['verify-email-address']);
      });
  }*/
  updateConsentStatus(consentStatus: boolean | undefined): void {
    this.cookieConsentService.persistConsentStatus(consentStatus);
  }

  signUpEvent(trialPlan) {
    const today = Date.UTC(
      new Date().getFullYear(),
      new Date().getUTCMonth(),
      new Date().getDate()
    );
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 14);
    const trialEndFullDate = Date.UTC(
      currentDate.getFullYear(),
      currentDate.getUTCMonth(),
      currentDate.getDate()
    );

    this.hubspotService.createSignupEvent({
      properties: {
        user_id: this.userId,
        firstname: this.userSignUpInfo.firstName,
        lastname: this.userSignUpInfo.lastName,
        full_name: `${this.userSignUpInfo.firstName} ${this.userSignUpInfo.lastName}`,
        user_type: this.userRole,
        company: this.userSignUpInfo.company.name,
        email: this.userSignUpInfo.email,
        trial_created: today,
        trial_started: today,
        trial_ended: trialEndFullDate,
        current_subscription_plan: get(trialPlan, 'plan.planId', 'trial'), //TODO New Subscription Check for any changes.
      },
    });
  }

  private handleAuthFailure(e: unknown, fallback: string): void {
    traceFailure(fallback, { code: this.toErrorCode(e, fallback) });
    this.appService.authValidationInProgress = false;
    this.showSpinner = false;
    this.showFailedMsg = { code: this.toErrorCode(e, fallback) };
  }

  private toErrorCode(e: unknown, fallback: string): string {
    return (e as { code?: string })?.code ?? fallback;
  }

  /** Navigates to the logout route as a sign-out the user asked for ("Logout and try again"). */
  logout() {
    markExplicitLogout();
    this.router.navigate(['logout']);
  }

  ngOnDestroy() {
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }
  }
}
